import { CommonModule } from '@angular/common';
import { AfterViewChecked, Component, ElementRef, ViewChild } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { AIAgentService } from '@shared/services/ai-agent.service';
import { SharedModule } from '@shared/shared.module';
import { marked } from 'marked';

@Component({
  selector: 'app-aiagent',
  imports: [CommonModule, SharedModule, FormsModule],
  templateUrl: './aiagent.component.html',
  styleUrl: './aiagent.component.scss'
})
export class AIAgentComponent implements AfterViewChecked {
  @ViewChild('chatBody') chatBody!: ElementRef;
  isThinking: boolean = false;
  constructor(private aiAgentService: AIAgentService) { }
  messages: { sender: 'user' | 'bot', text: string }[] = [
    { sender: 'bot', text: 'Hello! How can I help you today?' },
    { sender: 'user', text: 'get the detail of top selling product for today' }
  ];
  userInput: string = '';
  ngAfterViewChecked() {
    this.scrollToBottom();
  }
  sendMessage(event: any) {
    if (event && event.shiftKey) return;


    if (!this.userInput.trim()) return;
    this.isThinking = true;
    const prompt = this.userInput;
    this.messages.push({ sender: 'user', text: prompt });
    this.userInput = '';
    this.aiAgentService.askQuestion(prompt).subscribe(result => {
      this.messages.push({ sender: 'bot', text: result.response });
      this.scrollToBottom();
      this.isThinking = false;
    }, error => {
      this.messages.push({ sender: 'bot', text: 'Sorry, I could not process your request.' });
      this.isThinking = false;

    });
  }
  scrollToBottom() {
    //scroll down chatBody to buttom
    if (this.chatBody && this.chatBody.nativeElement) {
      this.chatBody.nativeElement.scrollTop = this.chatBody.nativeElement.scrollHeight;
    }

  }

  formatOpenAIMessage(text: string): string {
    // Basic HTML escaping
    // let html = text
    //   .replace(/&/g, '&amp;')
    //   .replace(/</g, '&lt;')
    //   .replace(/>/g, '&gt;');

    // // Markdown: code blocks
    // html = html.replace(/```([\s\S]*?)```/g, '<pre><code>$1</code></pre>');
    // // Inline code
    // html = html.replace(/`([^`]+)`/g, '<code>$1</code>');
    // // Bold
    // html = html.replace(/\*\*(.*?)\*\*/g, '<b>$1</b>');
    // // Italic
    // html = html.replace(/\*(.*?)\*/g, '<i>$1</i>');
    // // Bullet points
    // html = html.replace(/(^|\n)- (.*?)(?=\n|$)/g, '$1<ul><li>$2</li></ul>');
    // html = html.replace(/<\/ul>\s*<ul>/g, ''); // Merge consecutive <ul>
    // // Numbered lists
    // html = html.replace(/(^|\n)\d+\. (.*?)(?=\n|$)/g, '$1<ol><li>$2</li></ol>');
    // html = html.replace(/<\/ol>\s*<ol>/g, '');
    // // Links
    // html = html.replace(/\[([^\]]+)\]\(([^)]+)\)/g, '<a href="$2" target="_blank">$1</a>');
    // // New lines
    // html = html.replace(/\n\n/g, '<br><br>');
    // html = html.replace(/\n/g, '<br>');

    //return html;
    return marked(text) as string; // convert Markdown → safe HTML
  }
}
